import React, { useCallback } from 'react';
import { route, routeQuery } from '../../../../services/utils';
import OptionModal from '../../../../components/modals/option-modal';
import { useTranslation } from 'react-i18next';
import { useParams, useHistory } from 'react-router';
import TabsKeys from '../../../../enums/tab-keys';
import { WAREHOUSE_MOVEMENT_INDEX } from '../../../../router/routes';
import css from '../index.module.css';
import { UseFormReturn } from 'react-hook-form';

export default function useDealErrorModal(formMethods: UseFormReturn) {
  const history = useHistory();
  const { farmId } = useParams<{
    farmId: string;
  }>();
  const { t } = useTranslation();
  const tp = useCallback(
    (key: string) => t('pages.warehouse.deals.'.concat(key)),
    [t]
  );

  const deletionBlockErrorMessage = formMethods.getFieldState(
    'deal_product_ids_blocking_deletion'
  )?.error?.message;

  const deletionModal = () => {
    return (
      deletionBlockErrorMessage && (
        <OptionModal
          title={tp('relationship_deals_title_edit')}
          className={css['delete-modal_wrapper']}
          content={
            <div className={css['modal-delete_description']}>
              {tp('description_move_to_deals_edit')}
            </div>
          }
          buttons={[
            {
              title: tp('move_to_deals'),
              name: 'yes',
              value: true,
              ignoreValidation: true,
            },
            {
              title: t('cancel'),
              name: 'no',
              value: false,
              ignoreValidation: true,
            },
          ]}
          onChoice={(choice) => {
            if (choice) {
              sessionStorage.removeItem('current_index_page');
              history.push(
                routeQuery(
                  route(WAREHOUSE_MOVEMENT_INDEX, {
                    farmId: farmId,
                    tab: TabsKeys.deals,
                  }),
                  {
                    ids: deletionBlockErrorMessage.split(','),
                  }
                )
              );
            }
            formMethods.clearErrors('deal_product_ids_blocking_deletion');
          }}
          onClose={() =>
            formMethods.clearErrors('deal_product_ids_blocking_deletion')
          }
        />
      )
    );
  };

  const validationErrors =
    !!Object.keys(formMethods?.formState?.errors?.products ?? {}).length &&
    !deletionBlockErrorMessage;

  const validationModal = () => {
    return (
      validationErrors && (
        <OptionModal
          title={t('components.sidebar.warehouse.title')}
          className={css['delete-modal_wrapper']}
          content={
            <div className={css['modal-delete_description']}>
              {tp('description_validation_error')}
            </div>
          }
          buttons={[
            {
              title: t('cancel'),
              name: 'yes',
              value: true,
              ignoreValidation: true,
            },
          ]}
          onChoice={() => {
            formMethods.clearErrors();
          }}
          onClose={() => formMethods.clearErrors()}
        />
      )
    );
  };

  return (
    <>
      {deletionModal()}
      {validationModal()}
    </>
  );
}
